import { get as nestedGet } from 'nested-property'
import { ShortcutArgs } from '../../types'
import { getDateString } from '../dates'
import { formatPhoneNumber } from '../fields'
import { getFullName, getFullNameWithMiddleInitial, getReverseName } from '../users'
import { getAddressValue } from './address'

const getFullNameValue = (path: string, shortcutArgs: ShortcutArgs): string | undefined => {
  const { user } = shortcutArgs ?? {}
  const [fieldPath] = path.split('.')
  switch (fieldPath) {
    case 'fullName':
      return getFullName(user, true)
    case 'reverseName':
      return getReverseName(user)
    case 'fullNameWithMiddle':
      return getFullName(user, false)
    case 'fullNameWithMiddleInitial':
      return getFullNameWithMiddleInitial(user)
    default:
      return undefined
  }
}

export const getPatientValue = (path: string, shortcutArgs: ShortcutArgs): string | undefined => {
  // ex: payments.received.0
  const { assessment, user } = shortcutArgs ?? {}
  const [, fieldPath, ...rest] = path.split('.')
  const { mergedSignOnData, plans } = assessment ?? {}
  const primaryCoverage = plans?.primary
  const primaryCoverageAddress = primaryCoverage?.address
  const homeAddress =
    mergedSignOnData?.homeAddressSameAsPatientAddress && primaryCoverageAddress
      ? primaryCoverageAddress
      : mergedSignOnData?.homeAddress

  if (!fieldPath) return undefined
  switch (fieldPath) {
    case 'address':
    case 'address2':
      return getAddressValue(
        'address',
        `${fieldPath}${rest.length ? `.${rest.join('.')}` : ''}`,
        primaryCoverageAddress,
      )
    case 'homeAddress':
    case 'homeAddress2':
      return getAddressValue(
        'homeAddress',
        `address${rest.length ? `.${rest.join('.')}` : ''}`,
        homeAddress,
      )
    case 'fullName':
      return getFullNameValue(rest.join('.'), shortcutArgs)
    case 'dob':
      return user?.dob ? getDateString(user.dob, 'short') : undefined
    case 'phone':
      return user?.phone ? formatPhoneNumber(user.phone) : undefined
    default: {
      return nestedGet(user, fieldPath)
    }
  }
}
